export const colorClassForNotificationPopOver = {
  read: "read-color",
  delivered: "unread-color",
  unDelivered: "unread-color",
};

export const calculateTotalCount = (count) => {
  if (count.delivered && count.unDelivered) return count.delivered + count.unDelivered;
  else return count.delivered || count.unDelivered || 0;
};
